export const API_KEY = "AIzaSyBDIDQ9SePlX_tIVEArgIUGne0JZdB5kWw";

export default API_KEY;